import { userUpsertModalRouteStore } from '../components/user-upsert-modal/domain/store';

export default (showing = true) => {
  userUpsertModalRouteStore.setValue('showingDeleteConfirmationModal', showing);
};
